export default (context) => {
    context.commit('setArchived', false);
    context.dispatch('saveState');
    context.dispatch('getData')
}


// WEBPACK FOOTER //
// ./src/app/store/base/actions/hide-archived.js